import { render, staticRenderFns } from "./MyPicStoreModal.vue?vue&type=template&id=80cae6d0&scoped=true"
import script from "./MyPicStoreModal.vue?vue&type=script&lang=js"
export * from "./MyPicStoreModal.vue?vue&type=script&lang=js"
import style0 from "./MyPicStoreModal.vue?vue&type=style&index=0&id=80cae6d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80cae6d0",
  null
  
)

export default component.exports